export const iconFontAwesomeWritingBook = (
	<i className="fa-solid fa-book"></i>
);
